import routes from 'sitewide-js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { ResourceType } from 'js/social/shared/types';

export async function deleteTag(
  id: number | string,
  resourceType: ResourceType,
) {
  const route = {
    post: routes.api_v0_community_post_tag_path,
    comment: routes.api_v0_community_comment_tag_path,
    paper_update: routes.api_v0_community_paper_update_tag_path,
    openalex_work: (_: any) => '',
    work: (_: any) => '',
    paper_set: (_: any) => '',
  }[resourceType];
  if (!route) return;

  const response = await fetchWithCsrf(
    route({ subdomain_param: 'api', [`${resourceType}_id`]: id }),
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
    },
  );
  if (response.status !== 200) {
    throw new Error('Failed to delete tag');
  }
  return await response.json();
}
